import useRevalidateFileDetail from '@/modules/FileDetail/hooks/useRevalidateFileDetail';
import { backForCorrectionActionMutationFn } from '@/modules/FileDetail/queries/sendActions/backForCorrectionAction/backForCorrectionActionMutationFn';
import { BackForCorrectionActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/backForCorrectionAction/backForCorrectionActionMutationFn.types';
import { useMutation } from '@tanstack/react-query';

const useBackForCorrectionActionMutation = (id: string) => {
  const { revalidateFileDetail } = useRevalidateFileDetail(id);

  return useMutation({
    mutationFn: (data: BackForCorrectionActionMutationDataType) =>
      backForCorrectionActionMutationFn(data, id),
    meta: {
      successToast: 'اقدام با موفقیت انجام شد',
    },
    onSuccess: () => {
      return revalidateFileDetail();
    },
  });
};

export default useBackForCorrectionActionMutation;
